"use client";

import { TriangleAlert } from "lucide-react";
import { useTranslations } from "next-intl";
import { useSearchParams } from "next/navigation";
import { Alert, AlertDescription } from "@/components/ui/alert";

const KNOWN = ["expired", "error", "refused", "unverified", "invitation-ended"] as const;

/** Explains why a sign-in did not finish, from the ?signin= the sign-in route adds when it sends people back. */
export function SignInNotice() {
  const t = useTranslations("auth.notice");
  const value = useSearchParams().get("signin");
  const known = KNOWN.find((k) => k === value);
  if (!known) return null;
  return (
    <Alert variant="destructive" className="mx-auto mt-4 max-w-2xl">
      <TriangleAlert />
      <AlertDescription>{t(known)}</AlertDescription>
    </Alert>
  );
}
